import { cn } from "@/lib/utils"

declare global {
  interface RegExpConstructor {
    escape(str: string): string
  }
}

const highlightSearch = (text: string, searchValue: string, extendedMarkClasses: string = "") => {
  const regex = new RegExp(RegExp.escape(searchValue).split(/\s+/gi).join("|"), "gi")
  const markClasses = !extendedMarkClasses ? "font-medium" : extendedMarkClasses
  return text.replace(
    regex,
    (match) => `<mark class="${cn("bg-success-surface-subdued text-on-success-surface", markClasses)}">${match}</mark>`,
  )
}

export { highlightSearch }
